/**
 * MINI-MIRROR CALIBRATION CONSTANTS — DO NOT REFACTOR WITHOUT READING THIS
 *
 * The boolean `isAvaturnModel` is LEGACY NAMING. It does NOT mean "the user's
 * avatar is Avaturn-provided". It means "use calibration-type-A in AvatarCore,
 * which applies scaleOverride + lookAtYOverride".
 *
 * All current `/prerendered/*.glb` files (catalog free tier) are Avaturn-origin
 * Y-up exports. The whole calibration system was written assuming Avaturn-style
 * geometry. MetaPerson dynamic avatars (Premium tier, v1.1+) will need a
 * separate calibration path. Until then, mini-mirrors MUST pass
 * isAvaturnModel=true REGARDLESS of the user's `avatar_provider` DB value.
 *
 * Renaming this constant or flipping it to false will re-introduce the
 * mini-mirror head-crop bug fixed in this hotfix (commit stacked on 5a4b82b).
 *
 * See: docs/avaturn-deprecation-discovery.md — Sub-task C Hotfix v2 section.
 */
export const MINI_MIRROR_IS_AVATURN_MODEL = true;
export const MINI_MIRROR_SCALE = 1.6;
export const MINI_MIRROR_LOOK_AT_Y = 2.5;
export const MINI_MIRROR_CAMERA_DISTANCE = 1.7;
export const MINI_MIRROR_FRAMING = "bust" as const;

/**
 * FULL_BODY_IS_AVATURN_MODEL — same legacy-naming guard as the mini-mirror
 * constant above, exported with a distinct name for grep-clarity at the
 * full-body call sites (MirrorHome / Modules / FitnessBodyMap).
 *
 * Why a separate export instead of reusing MINI_MIRROR_IS_AVATURN_MODEL:
 * future v1.1 calibration window may diverge the two — mini-mirror could
 * adopt MP dynamic calibration while full-body still uses Avaturn-profile,
 * or vice versa. Distinct symbols let that split happen mechanically
 * without grep-renaming hundreds of call-sites. Today both `= true`.
 *
 * Calibration values (scaleOverride / lookAtYOverride / cameraDistanceOverride)
 * are intentionally NOT centralized here for the full-body consumers —
 * MirrorHome and Modules share lookAtY=1.3 + cameraDistance=4.7, but
 * FitnessBodyMap uses cameraDistance=4.5 (different camera placement
 * because of the body-map overlay). Per-consumer values stay inline.
 */
export const FULL_BODY_IS_AVATURN_MODEL = true;
